module.exports = __webpack_public_path__ + "assets/img/dp.729032d6.png";